import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { DropdownStyled } from 'src/components';
import { useCurrentUser } from 'src/hooks';
import { historyFilterByAtom } from 'src/store';
import { FilterItems } from './filterAndSortBlocks';

/**
 * DOES NOT SHOW on mobile sized views
 */
export const FilterByDropdown = () => {
  const { user } = useCurrentUser();
  const [filterBy] = useAtom(historyFilterByAtom);
  const { t, i18n } = useTranslation();

  const isAdminOrApprover =
    user?.subscription?.tier === 'organization' &&
    (user?.subscription?.role === 'admin' ||
      user?.subscription?.role === 'approver');

  const i18nLang = i18n.resolvedLanguage
    ? i18n.resolvedLanguage.toLowerCase()
    : i18n.language.toLowerCase();

  // Determine width based on language
  const widthClass =
    i18nLang === 'en'
      ? 'w-[176px]'
      : i18nLang === 'es'
        ? 'w-[190px]'
        : i18nLang === 'ru'
          ? 'w-[242px]'
          : i18nLang === 'zh'
            ? 'w-[160px]'
            : 'w-[176px]';

  return (
    <DropdownStyled
      className={widthClass}
      buttonContent={
        <span className='truncate whitespace-nowrap text-cloudGray'>
          {isAdminOrApprover && filterBy === 'sent_and_received'
            ? t('history.filters.all_personal_label')
            : isAdminOrApprover && filterBy === 'all_org'
              ? t('history.filters.all_org_label')
              : t(`history.filters.${filterBy}`)}
        </span>
      }
    >
      {(closeDropdown) => (
        <FilterItems
          closeDropdown={closeDropdown}
          showMainLabel={false}
          isMobile={false}
        />
      )}
    </DropdownStyled>
  );
};
